// extracted by mini-css-extract-plugin
export default {"container":"pending-post_container__FsE8I","stateString":"pending-post_stateString__6wzCb"};